<template>
  <div class="settings">
    <img
      class="settings__button--main"
      src="@/assets/practices/global/settings/button_settings.svg"
      alt="Settings"
      @click="settings"
    />
    <div v-show="settingsStatus" class="settings__wheel">
      <img
        class="settings__background"
        src="@/assets/practices/global/settings/settings_background.svg"
        alt="Settings Background"
      />
      <div class="settings__mute">
        <img
          v-if="!muteStatus"
          class="settings__button--mute"
          src="@/assets/practices/global/settings/button_sound.svg"
          alt="Sound Enabled"
          @click="mute"
        />
        <img
          v-if="muteStatus"
          class="settings__button--mute"
          src="@/assets/practices/global/settings/button_sound_muted.svg"
          alt="Sound Disabled"
          @click="mute"
        />
      </div>
      <div class="settings__speech">
        <img
          v-if="speechStatus"
          class="settings__button--speech"
          src="@/assets/practices/global/settings/button_speech.svg"
          alt="Text-to-Speech Enabled"
          @click="speech"
        />
        <img
          v-if="!speechStatus"
          class="settings__button--speech"
          src="@/assets/practices/global/settings/button_speech_muted.svg"
          alt="Text-to-Speech Disabled"
          @click="speech"
        />
      </div>
      <a class="settings__exit" href="javascript:window.location.href=window.location.origin">
        <img
          href="/"
          class="settings__button--exit"
          src="@/assets/practices/global/settings/button_exit.svg"
          alt="Exit"
          @click="exit"
        />
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import { Howl, Howler } from 'howler';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'Settings',
  computed: {
    ...mapGetters({
      muteStatus: 'settings/muteStatus',
      settingsStatus: 'settings/settingsStatus',
      speechStatus: 'settings/speechStatus',
    }),
  },
  methods: {
    exit() {
      sounds.globalButtonSettings.play();
      console.log('Exit button has been clicked...');
    },
    mute() {
      sounds.globalButtonSettings.play();
      this.$store.state.settings.muteStatus = !this.$store.state.settings.muteStatus;
      if (!this.muteStatus) {
        console.log('Sound has been enabled...');
      } else {
        console.log('Sound has been disabled...');
      }
    },
    settings() {
      sounds.globalButtonSettings.play();
      this.$store.state.settings.settingsStatus = !this.$store.state.settings.settingsStatus;
      if (this.settingsStatus) {
        console.log('Settings menu has been enabled...');
      } else {
        console.log('Settings menu has been disabled...');
      }
    },
    speech() {
      sounds.globalButtonSettings.play();
      // For specific "game" configuration use:
      // this.$store.state[this.game].speechStatus = !this.$store.state[this.game]
      //   .speechStatus;
      this.$store.state.settings.speechStatus = !this.$store.state.settings.speechStatus;
      if (this.speechStatus) {
        console.log('Text-to-Speech has been enabled...');
      } else {
        console.log('Text-to-Speech has been disabled...');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin flex {
  display: flex;
  justify-content: center;
}

$button-size: 22%;

.settings {
  align-items: center;
  bottom: 1vh;
  display: flex;
  // height: 48vh;
  justify-content: center;
  left: 1vh;
  position: absolute;
  // transform: translate(-37%, 37%);
  // width: 48vh;
  z-index: 100;

  .settings__button--main {
    cursor: pointer;
    // height: $button-size;
    height: 10.5vh;
    z-index: 101;
  }

  .settings__wheel {
    align-items: center;
    display: flex;
    justify-content: center;
    height: 48vh;
    position: absolute;

    .settings__background {
      animation: wheel-bg 0.3s forwards;
    }

    .settings {
      &__mute,
      &__speech,
      &__exit {
        animation: wheel-button 1s forwards;
        // height: $button-size;
        height: 10.5vh;
        position: absolute;
        transform-origin: center center;
      }
    }

    .settings__mute {
      top: 3.5%;
    }

    .settings__speech {
      right: 15.5%;
      top: 14.5%;
    }

    .settings__exit {
      right: 3.5%;
    }

    .settings__button {
      &--mute,
      &--speech,
      &--exit {
        cursor: pointer;
        height: 100%;
      }
    }
  }
}

@keyframes wheel {
  0% {
    opacity: 0;
  }

  15% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }
}

@keyframes wheel-bg {
  0% {
    height: 0%;
  }

  100% {
    height: 100%;
  }
}

@keyframes wheel-button {
  0% {
    opacity: 0;
    transform: scale(1, 1);
  }

  40% {
    opacity: 0;
    transform: scale(1, 1);
  }

  60% {
    opacity: 1;
    transform: scale(1.5, 1.5);
  }

  80% {
    opacity: 1;
    transform: scale(0.75, 0.75);
  }

  100% {
    opacity: 1;
    transform: scale(1, 1);
  }
}
</style>
